import moment from "moment";
import React from "react";
import { Link } from "react-router-dom";
import { isEmpty } from "../../libs";

function ResultPage({ props }) {
  const { data } = props;

  return (
    <div className="result">
      <div className="container mx-auto py-6 lg:py-10">
        <div className="w-full flex justify-center">
          <div className="w-full lg:w-3/5 ">
            <div>
              {/* <p className="header-content text-center colors-gray mb-5">
                Dipersembahkan Oleh
              </p> */}
            </div>
            <div className="flex justify-center mb-7 lg:mb-10">
  <Link to="/">
    <img
      src={process.env.REACT_APP_BASE_URL + "/assets/logo/labkesmassby.png"}
      alt="blk-logo"
      className="cursor-pointer h-32 lg:h-56 w-auto"
    />
  </Link>
</div>
            <div className="result-wrapper ">
              <div className="p-5 lg:px-12 lg:pt-10">
                <p className="header-title-bold text-xl text-center lg:text-3xl colors-blue font-bold mb-3 lg:mb-6">
                  Hasil Laboratorium
                </p>

                <p className="header-title-semi text-lg lg:text-xl colors-blue font-semibold mb-3 lg:mb-6">
                  Kami menerangkan bahwa :
                </p>

                <div className="mb-10">
                  <p className="header-title-semi colors-blue font-semibold text-lg lg:text-2xl mb-3 lg:mb-5">
                    Informasi Pribadi
                  </p>
                  <div className="flex mb-3 justify-between ">
                    <p className="header-content colors-gray text-sm lg:text-base">
                      Nama Pasien
                    </p>
                    <p className="header-content colors-blue text-sm lg:text-base font-semibold">
                      {data?.full_name ?? ""}
                    </p>
                  </div>
                  <div className="flex mb-3 justify-between ">
                    <p className="header-content colors-gray text-sm lg:text-base">
                      No. Kwitansi
                    </p>
                    <p className="header-content colors-blue text-sm lg:text-base font-semibold">
                      {data?.invoice ?? ""}
                    </p>
                  </div>
                  <div className="flex mb-3 justify-between ">
                    <p className="header-content colors-gray text-sm lg:text-base">
                      Alamat
                    </p>
                    <p className="w-3/5 text-right header-content colors-blue text-sm lg:text-base font-semibold overflow-ellipsis">
                      {data?.alamat ?? ""}
                      {" " + data?.kecamatan ?? ""}
                      {" " + data?.kota ?? ""}
                      {" " + data?.provinsi ?? ""}
                    </p>
                  </div>
                </div>
                <div className="mb-6">
  {(() => {
    // ====== sumber data ======
    const hasil = Array.isArray(data?.hasil) ? data.hasil : [];

    // ====== mapping instalasi ======
    const INST_TTD = new Set([2, 4, 15, 16]);
    const INST_MIK = new Set([3, 5, 6, 8]);
    const INST_PA  = new Set([19]);
    const INST_RAD = new Set([14, 17]);

    // ====== nama & NIP dokter dari payload ======
    const dokterTTD = data?.dokter_ttd?.trim?.() || "-";

    const dokterKIM = data?.dokter_ttd_kimkes?.trim?.() || "-";
    const dokterMIK = data?.dokter_ttd_mikro?.trim?.() || "-";
    const dokterPA  = data?.dokter_ttd_patologianatomi?.trim?.() || "-";
    const dokterRAD = data?.dokter_ttd_radiologi?.trim?.() || "-";

    const nipTTD = data?.nip_ttd?.trim?.() || "";
    const nipKIM = data?.nip_ttd_kimkes?.trim?.() || "";
    const nipMIK = data?.nip_ttd_mikro?.trim?.() || "";
    const nipPA  = data?.nip_ttd_patologianatomi?.trim?.() || "";
    const nipRAD = data?.nip_ttd_radiologi?.trim?.() || "";

    // util sederhana — hapus semua tag selain sub/sup dan buang atributnya
const allowSubSup = (html = "") =>
  html
    .replace(/<(?!\/?(?:sub|sup)\b)[^>]*>/gi, "")
    .replace(/<(\/?)(sub|sup)\b[^>]*>/gi, "<$1$2>");

    const renderSection = (key, judulNode, list) => {
  if (!list.length) return null;

  const paketListOf = (p) => {
    if (!p) return [];
    if (Array.isArray(p)) return p.filter(Boolean).map(x => String(x).trim());
    return String(p).split(",").map(s => s.trim()).filter(Boolean);
  };
  const itemKey = (it) => (it?.result_id ?? it?.nama_pemeriksaan ?? Math.random());

  const groups = new Map();
  const order = [];
  for (const it of list) {
    const paketArr = paketListOf(it?.paket_nama);
    const targetPaket = paketArr.length ? paketArr : ["Lainnya"];
    for (const name of targetPaket) {
      if (!groups.has(name)) {
        groups.set(name, { items: [], seen: new Set() });
        order.push(name);
      }
      const g = groups.get(name);
      const k = itemKey(it);
      if (!g.seen.has(k)) {
        g.seen.add(k);
        g.items.push(it);
      }
    }
  }

  return (
    <div key={key} className="mb-6">
      <p className="header-title-semi colors-blue font-semibold text-lg lg:text-2xl mb-2">
        Telah melakukan pemeriksaan :
      </p>

      {order.map((pkg) => {
        const { items } = groups.get(pkg) || { items: [] };
        if (!items.length) return null;

        if (pkg === "Lainnya") {
          // TANPA PAKET → item bold
          return (
            <div key={pkg} className="mb-2">
              {items.map((it, idx) => (
                <div
                  key={itemKey(it) + "-" + idx}
                  className="header-title-semi text-lg lg:text-xl colors-blue font-semibold mb-2"
                >
                  <span
                    dangerouslySetInnerHTML={{
                      __html: allowSubSup(it?.nama_pemeriksaan || ""),
                    }}
                  />
                </div>
              ))}
            </div>
          );
        }

        // DENGAN PAKET → judul paket bold, item normal
        return (
          <div key={pkg} className="mb-4">
            <p className="colors-blue text-base lg:text-xl font-semibold mb-2">
              {pkg}
            </p>
            <ul className="list-disc pl-6 lg:pl-8">
              {items.map((it, idx) => (
                <li
                  key={itemKey(it) + "-" + idx}
                  className="header-title-semi text-lg lg:text-xl colors-blue mb-2" // ← no font-semibold
                >
                  <span
                    dangerouslySetInnerHTML={{
                      __html: allowSubSup(it?.nama_pemeriksaan || ""),
                    }}
                  />
                </li>
              ))}
            </ul>
          </div>
        );
      })}

      <p className="header-title-semi colors-blue font-semibold text-lg lg:text-2xl mt-2">
        {judulNode}
      </p>
    </div>
  );
};

  
    // ====== build list per dokter (termasuk aturan khusus instalasi 1) ======
    const listTTD = hasil.filter(h => {
      const inst = Number(h?.instalasi_id);
      const tipe = Number(h?.tipe_pemeriksaan);
      return INST_TTD.has(inst) || (inst === 1 && tipe === 1);
    });

    const listCekFisik = hasil.filter(h =>
        Number(h?.parameter_id) === 2680
    );

    const listKIM = hasil.filter(h => {
      const inst = Number(h?.instalasi_id);
      const tipe = Number(h?.tipe_pemeriksaan);
      return inst === 1 && tipe === 2;
    });

    const listRAD = hasil.filter(h =>
      INST_RAD.has(Number(h?.instalasi_id))
    );

    const listMIK = hasil.filter(h => INST_MIK.has(Number(h?.instalasi_id)));
    const listPA  = hasil.filter(h => INST_PA.has(Number(h?.instalasi_id)));

    // ====== susun sections ======
    const sections = [];

    // TTD
        const dokterCekFisik =
    data?.dokter_cek_fisik?.trim?.() || "-";

    const nipCekFisik =
    data?.nip_cek_fisik?.trim?.() || "";
    if (data?.dokter_ttd && dokterTTD !== "-" && listTTD.length) {
      sections.push(
        renderSection(
          "ttd",
          <>
            Telah diverifikasi oleh
            <br />
            <strong>{dokterTTD}</strong>
            {nipTTD && (
              <>
                <br />
                {nipTTD}
              </>
            )}
          </>,
          listTTD
        )
      );
    }

    // KIMKES
    if (data?.dokter_ttd_kimkes && dokterKIM !== "-" && listKIM.length) {
      sections.push(
        renderSection(
          "kim",
          <>
            Telah diverifikasi oleh
            <br />
            <strong>
              Kepala Instalasi Kesehatan Lingkungan, Vektor dan Binatang Pembawa
              Penyakit
            </strong>
            <br />
            <strong>{dokterKIM}</strong>
            {nipKIM && (
              <>
                <br />
                {nipKIM}
              </>
            )}
          </>,
          listKIM
        )
      );
    }

    // MIKRO
    if (data?.dokter_ttd_mikro && dokterMIK !== "-" && listMIK.length) {
      sections.push(
        renderSection(
          "mik",
          <>
            Telah diverifikasi oleh
            <br />
            <strong>{dokterMIK}</strong>
            {nipMIK && (
              <>
                <br />
                {nipMIK}
              </>
            )}
          </>,
          listMIK
        )
      );
    }

    // PA
    if (data?.dokter_ttd_patologianatomi && dokterPA !== "-" && listPA.length) {
      sections.push(
        renderSection(
          "pa",
          <>
            Telah diverifikasi oleh
            <br />
            <strong>{dokterPA}</strong>
            {nipPA && (
              <>
                <br />
                {nipPA}
              </>
            )}
          </>,
          listPA
        )
      );
    }

    // RADIOLOGI
if (data?.dokter_ttd_radiologi && dokterRAD !== "-" && listRAD.length) {
  sections.push(
    renderSection(
      "rad",
      <>
        Telah diverifikasi oleh
        <br />
        <strong>{dokterRAD}</strong>
        {nipRAD && (
          <>
            <br />
            {nipRAD}
          </>
        )}
      </>,
      listRAD
    )
  );
}

if (
    dokterCekFisik !== "-" &&
    listCekFisik.length
) {
    sections.push(
        renderSection(
            "cekfisik",
            <>
                Pemeriksaan cek fisik telah diverifikasi oleh
                <br />
                <strong>{dokterCekFisik}</strong>

                {nipCekFisik && (
                    <>
                        <br />
                        {nipCekFisik}
                    </>
                )}
            </>,
            listCekFisik
        )
    );
}

    // ====== fallback jika tidak ada section terisi ======
    if (sections.length === 0) {
      return (
        <>
          <p className="header-title-semi colors-blue font-semibold text-lg lg:text-2xl mb-3 lg:mb-5">
            Telah melakukan test
          </p>
          {hasil.map((it, idx) => (
            <p
              key={idx}
              className="header-title-semi text-lg lg:text-xl colors-blue font-semibold mb-3"
            >
              • {it?.nama_pemeriksaan ?? ""} dengan hasil "
              {it?.result_value ?? ""}"
            </p>
          ))}
        </>
      );
    }

    return sections;
  })()}
</div>


              </div>
              {/* Gradient Section */}
              <div className="result-gradient ">
                <div className="flex items-center content-center justify-between h-full p-2  lg:px-10">
                  {/* <p className="header-content colors-blue text-sm lg:text-base font-semibold">
                    • Tanggal Dikeluarkan Hasil Ini
                  </p> */}
                  {/* <p className="header-content colors-blue text-sm lg:text-base font-bold ">
                    {moment(data?.waktu_tg_rilis ?? "00-00-0000").format(
                      "DD MMMM YYYY"
                    )}
                  </p> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResultPage;
